




















































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

import FlightReservationOrder from "@/store/entities/flight/reservation/flightReservationOrder";
import ReservationList from "@/store/entities/flight/reservation/reservationList";
import PassengerInherit from "@/store/entities/passangerInherit";
import CancelOrder from "@/store/entities/flight/reservation/cancelOrder";
import ApproveOrderById from "@/store/entities/flight/reservation/approveOrderById";
import Customer from "@/store/entities/customer";
import ajax from "@/lib/ajax";
import Refund from "@/store/entities/refund";
import Currency from "@/store/entities/currency";
@Component({
  components: {
  },
})
export default class ReservationDetailModal extends Vue {
  radios: boolean = true;
  dialog: boolean = true;
  dialogAgree: boolean = false;
  dialogRefund: boolean = false;
  dialogAmount: boolean = false;
  dialogChangeCurrency: boolean = false;
  dialogEmail: boolean = false;
  dialogConfirm: boolean = false;
  mockData: any[] = [];
  headersEmailMessage: any[] = [];
  headers: any[] = [];
  mockDataOperatorHistory: any[] = [];
  headersOperatorHistory: any[] = [];
  mockDataFlightOrder: any[] = [];
  headersFlightOrder: any[] = [];
  active_tab: number = 0;
  isOpenRow: boolean = false;
  isOpenFlightOrder: boolean = true;
  mockDataPassangers: any[] = [];
  headersPassangers: any[] = [];
  isOpenModal: boolean = false;
  isOpenCancelFlightOrderModal: boolean = false;
  isOpenPassengerEditModal: boolean = false;
  isOpenRemovePassengerModal: boolean = false;
  reservationList: FlightReservationOrder[] = [];
  flightOrders: FlightReservationOrder[] = [];
  passengers: PassengerInherit[] = [];
  flightNo: string;
  radioGroup: number | string = 1;
  cancelOrder: CancelOrder = new CancelOrder();
  orderId: string = "";
  dialogSalesEmail:boolean=false;
  emailMessages:any[]=[];
  additionalPayments:any[]=[];
  currencyId:string;
  pdfLink:string="";
  isOpenEmailList: boolean = false;
  isOpenAddList:boolean=false;
  refundTotal:number=0;
  extraTotal:number=0;
  headersAdditionalPayments: any[] = [];
  currencies: Currency[] = [];
  currency:Currency=new Currency();
  amount:number=0;

  
  get totalPrice(){
    if(this.reservationList.length>1){
      return this.reservationList[0].totalPrice +  this.reservationList[1].totalPrice 
    }
    return this.reservationList[0].totalPrice
    
  }

  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  }
 
  async created() {
    this.getCurrencies();
    this.reservationList = this.$store.state.reservation.reservationDetail;
    console.log("asdasd",this.reservationList[0])
    this.orderId=this.reservationList[0].orderId;
    this.currencyId=this.reservationList[0].currencyId;
  

    // if(this.reservationList[0].emailMessages.length>0){
    //   this.emailMessages=this.reservationList[0].emailMessages;
    // }
    // if(this.reservationList[0].order.additionalPayments.length>0){
    //   this.additionalPayments=this.reservationList[0].order.additionalPayments;
    // }

   
    
    // if(this.reservationList[0].order.orderStatus == 4){
    //     this.pdfUrl();
    // }

    (this.headersEmailMessage = [
      { text: "Kime", value: "emailTo" },
      { text: "Okundu", value: "isOpened" },
      { text: "Gönderildi", value: "isSent" },
      { text: "Spam", value: "isSpamReported" },
      { text: "Açılma Zamanı", value: "openedTime" },
      { text: "Gönderilme Zamanı", value: "sentTime" },
      { text: "Konu", value: "subject" },
    ]),

    (this.headersAdditionalPayments = [
      { text: "Ödeme Türü", value: "paymentRule" },
      { text: "Total", value: "total" },

    ]),


    
    (this.headers = [
      { text: "", value: "" },
      { text: "Ödeme Türü", value: "paymentType" },
      { text: "Ödeme Durumu", value: "paymentStatus" },
      { text: "Fiyat", value: "price" },
      { text: "Para Birimi", value: "currency" },
      { text: "Oluşturulma Tarihi", value: "creationDate" },
    ]),

      (this.headersOperatorHistory = [
        { text: "operator", value: "operator" },
        { text: "isAssigned", value: "isAssigned" },
        { text: "Operatör Durumu", value: "operatorStatus" },
        { text: "Not", value: "isNote" },
        { text: "Oluşturulma Tarihi", value: "creationDate" },
      ]),
      (this.headersFlightOrder = [
        { text: "", align: "start", filterable: false, value: "" },
        { text: "", align: "start", filterable: false, value: "" },
     
        { text: "Kalkış-Varış", value: "destination" },
        { text: "Transfer Tarihi", value: "creationDate" },
        { text: "Transfer Saati", value: "destination" },
     
        { text: "Yolcu Sayısı", value: "passangerCount" },

        { text: "Sipariş Durumu", value: "orderStatus" },
      ]),
      (this.headersPassangers = [
      
        { text: "İsim", value: "name" },
        { text: "Email", value: "birthday" },
        { text: "Gsm", value: "birthday" },
        { text: "Fiyat", value: "price" },
      ]);
  }

  async confirmReservation () {
   
    this.orderId=this.reservationList[0].orderId;
    await this.$store
      .dispatch({
        type: "reservation/approveOrderById",
        data: this.orderId,
       
      })
      .then((res) => {
        if (res.status === 200) {
          this.dialogConfirm = false;
          this.dialog = false;
          this.$emit("closed");
        }
      });


  }

  async sendTicketEmail() {
    let object: any = {};
    object.orderId = this.reservationList[0].orderId;
    object.emails = [this.reservationList[0].customer.email];
         
          this.closeDialog();
    await this.$store
      .dispatch({
        type: "reservation/sendTicketEmail",
        data: object,
      })
      .then((res) => {
        if (res.status === 200) {

          Vue.$toast.success("E-mail Gönderildi");
        }
      });
  }
  async updateCustomerInfo(){
    var customer = new Customer(); 
    customer.name=this.reservationList[0].customer.name;
    customer.surname=this.reservationList[0].customer.surname;
    customer.email=this.reservationList[0].customer.email;
    customer.gsm=this.reservationList[0].customer.gsm;
    customer.orderId=this.reservationList[0].orderId;
    await this.$store
      .dispatch({
        type: "customer/updateCustomerInformation",
        data: customer,
      })
      .then((res) => {
        if (res.status === 200) {

          Vue.$toast.success("Müşteri Bilgileri Güncellendi");
        }
      });
  }
  async updateBookingPayment(){
    let item ={"orderId":this.orderId,"totalPrice":this.amount,"currencyId":this.currency.id}
   
    await this.$store
      .dispatch({
        type: "reservation/updateBookingPayment",
        data: item,
      }).then((res) => {
        if (res.status === 200) {
            Vue.$toast.success("Rezervasyon Para Birimi Değişti");
            this.dialogChangeCurrency=false;
        }
        
      });
  }
  async saveRefund(paymentRule:number){
    var message="";
    let item = new Refund();
    item.orderId=this.reservationList[0].orderId;
    item.paymentRule=paymentRule;
    if(paymentRule==0){
      item.total=this.refundTotal;
      message="Kısmi İade Gerçekleşti.";
    }
    else{
      item.total=this.extraTotal;
      message="Tutar Ekleme Gerçekleşti.";
    }
    
    

    await this.$store
      .dispatch({
        type: "reservation/saveRefund",
        data: item,
      }).then((res) => {
        if (res.status === 200) {
            Vue.$toast.success(message);

        }
        
      });
     
      this.dialogRefund=false;
  }
  async sendTicketEmailForOperation() {
    let object: any = {};
    object.orderId = this.reservationList[0].orderId;
    object.emails = [this.reservationList[0].customer.email];

          this.closeDialog();
    await this.$store
      .dispatch({
        type: "reservation/sendTicketEmailForOperation",
        data: object,
      })
      .then((res) => {
        if (res.status === 200) {
          
          Vue.$toast.success("Operasyon Satış Maili Gönderildi");
        }
      });
  }
  async cancelReservation() {
    const array = [
      {
        orderId: this.reservationList[0].orderId,
        isOutOfProviderQuota: false,
        isOutOfQuota: false,
        flightOrderRefundRequests: [
          {
            orderId: this.reservationList[0].orderId,
            refundTo: 1,
            total: this.reservationList[0].totalPrice,
            currencyId: this.reservationList[0].currencyId,
          },
        ],
      },
    ];
    this.cancelOrder.orders = array;

    await this.$store
      .dispatch({
        type: "reservation/cancelOrder",
        data: this.cancelOrder,
      })
      .then((res) => {
        if (res.status === 200) {
          this.dialogAgree = false;
          this.dialog = false;
          this.$emit("closed");
        }
      });
  }

  data() {
    return {
      items: [
        { title: "Sipariş Ödeme" },
        { title: "İptal" },
        { title: "Gri Ödemeler" },
      ],
    };
  }

    async  pdfUrl(){
  
     var response= await this.$store
      .dispatch({
        type: "reservation/pdfLink",
        data: this.reservationList[0].orderId,
      })
      this.pdfLink = response;
     
  }

  get getPassengers() {
    return this.radioGroup === 1
      ? this.reservationList[0].passengers
      : this.reservationList[1].passengers;
  }

  get pnrAndFlightNo() {
    return this.radioGroup === 1
      ? `${this.reservationList[0].pnr} - ${this.reservationList[0].flightNo}`
      : `${this.reservationList[0].pnr} - ${this.reservationList[0].flightNo}`;
  }

  closeDialog() {
    this.$emit("closed");
  }

  openRow() {
    this.isOpenRow = true;
  }
  closeRow() {
    this.isOpenRow = false;
  }

  openFlightOrder() {
    this.isOpenFlightOrder = true;
  }
  closeFlightOrder() {
    this.isOpenFlightOrder = false;
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }

  openCancelFlightOrderModal() {
    this.isOpenCancelFlightOrderModal = true;
  }
  closeCancelFlightOrderModal() {
    this.isOpenCancelFlightOrderModal = false;
  }

  openPassengerEditModal() {
    this.isOpenPassengerEditModal = true;
  }
  closePassengerEditModal() {
    this.isOpenPassengerEditModal = false;
  }

  openRemovePassengerModal() {
    this.isOpenRemovePassengerModal = true;
  }
  closeRemovePassengerModal() {
    this.isOpenRemovePassengerModal = false;
  }

  openEmailList() {
    this.isOpenEmailList = true;
  }
  closeEmailList() {
    this.isOpenEmailList = false;
  }
  openAddList() {
    this.isOpenAddList = true;
  }
  closeAddList() {
    this.isOpenAddList = false;
  }

}
